// @flow
import update from 'immutability-helper';
import { OrderedMap } from 'immutable';

// import type { OrderedMap } from 'immutable';
import type { Notification } from '../../../entities';
import type { NotificationsAction } from './duck';

// This function is used to know if 2 notifications need to be grouped,
// it handle the logic to know if they're the same topic.
export function notificationAreSameTopic(n1: Notification, n2: Notification): boolean {
  return (
    ((n1.transaction && n2.transaction && n1.transaction.id === n2.transaction.id) ||
      (n1.order && n2.order && n1.order.id === n2.order.id)) &&
    (n1.subtype === n2.subtype));
}

export function notificationsCustomPrependOperation(orderedMap: OrderedMap<string, Notification>, item: Notification) {
  let newOrderedMap = orderedMap;
  // first: means the most recent notification
  const first: Notification = orderedMap.first() || { id: '', group: undefined };
  if (notificationAreSameTopic(first, item)) {
    if (first.group) {
      const newFirst = update(first, {
        $unset: ['group'],
      });
      const newGroup = [newFirst, ...first.group];
      const newItem = update(item, {
        group: { $set: newGroup },
      });
      const singleItemOrderedMap = OrderedMap([[newItem.id, newItem]]);
      newOrderedMap = singleItemOrderedMap.merge(newOrderedMap.delete(first.id));
    } else {
      const newItem = update(item, {
        group: { $set: [first] },
      });
      const singleItemOrderedMap = OrderedMap([[newItem.id, newItem]]);
      newOrderedMap = singleItemOrderedMap.merge(newOrderedMap.delete(first.id));
    }
  } else {
    const singleItemOrderedMap = OrderedMap([[item.id, item]]);
    newOrderedMap = singleItemOrderedMap.merge(orderedMap);
  }
  return newOrderedMap;
}

export function notificationsCustomIncrement(orderedMap: OrderedMap<string, Notification>, items: ?Notification[]) {
  let newOrderedMap = orderedMap;
  if (!items) return orderedMap;
  // This is the routine for grouping notifications
  items.forEach((item: Notification) => {
    let last = newOrderedMap.last() || { id: '', group: undefined };
    // Basically: if they are related they group up
    if (notificationAreSameTopic(last, item)) {
      // ensure group existence
      last.group = last.group ? last.group : [];
      // append item
      last = { ...last, group: [...last.group, item] };
      newOrderedMap = newOrderedMap.set(last.id, last);
    } else {
      newOrderedMap = newOrderedMap.set(item.id, item);
    }
  });
  return newOrderedMap;
}

export const notificationsCustomReadOperation = (map: OrderedMap<string, Notification>, action: NotificationsAction) =>
  !action.id ? map : map.update(action.id, (notification: Notification) => {
    // if (!notification) return undefined;
    let group = notification.group;
    if (group) group = group
      .filter((n: Notification) => !n.read)
      .map((n: Notification) => ({ ...n, read: true }));
    return { ...notification, group, read: true };
  });

export const notificationsCustomSeeAllOperation = (map: OrderedMap<string, Notification>) =>
  map.map((notification: Notification) => {
    // if (!notification) return undefined;
    let group = notification.group;
    if (group) group = group
      .filter((n: Notification) => !n.seen)
      .map((n: Notification) => ({ ...n, seen: true }));
    return { ...notification, group, seen: true };
  });

// TODO: handle delete notifications inside a group
export const notificationsCustomHideOperation = (map: OrderedMap<string, Notification>, action: NotificationsAction) =>
  !action.id ? map : map.delete(action.id);

export const countSingleUnseen = (map: OrderedMap<string, Notification>, action: NotificationsAction): number => {
  let count = 0;
  const notification = map.get(action.id || '');
  if (!notification) return count;
  if (!notification.seen) count++;
  if (notification.group) notification.group
    .filter((n: Notification) => !n.seen)
    .forEach((_: Notification) => count++);
  return count;
};



// WEBPACK FOOTER //
// ./src/modules/navbar/notifications/utils.js